export default __webpack_public_path__ + "static_text_wrapped_media.4fe13dc5.png";